import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { BaseService } from '../../services/base.service';

@Component({
  selector: 'app-tab-support-contact',
  templateUrl: './tab-support-contact.component.html',
  styleUrls: ['./tab-support-contact.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TabSupportContactComponent implements OnInit {
  panelOpenState = false;

  constructor(public readonly baseService: BaseService) {}

  open() {
    this.panelOpenState = true;
  }

  close() {
    this.panelOpenState = false;
  }

  ngOnInit() {}
}
